<div mat-dialog-title id="subscription-successful">Confirm Subscription
    <div class="dialog-close-button">
      <a (click)="onClose()" id="close">
        <img src="/assets/images/close-popup.png">
      </a>
    </div>
</div>
<form>
    <div mat-dialog-content cdkFocusInitial>
      <p class="cartText" name="confirm-msg" id="confirm-msg">By selecting CONFIRM below, you agree to the
        <span *ngIf="websiteName == 'Major'">Major Rugby </span><br>
        <span *ngIf="websiteName == 'Parmed'">{{websiteName}} </span><br>
        <span *ngIf="websiteName == 'Major'">Subscription <br></span>
        Subscription Program <a (click)="openSubscriptionHelpPage()">Terms & Conditions</a>
        <span *ngIf="websiteName == 'Major'">, including a<br>
        commitment to {{deliveryCountInWords}} ({{subscriptionDeliveryCount}}) shipments before changes to quantity<br>
        or delivery schedule can be made. Subscriptions will not be<br>
        eligible for our 'Skip', 'Edit Subscription', or 'Unsubscribe'<br>
        features until {{deliveryCountInWords}} ({{subscriptionDeliveryCount}}) shipments have been completed.</span>
      </p>
    </div>
    <div mat-dialog-actions>
        <button mat-raised-button [mat-dialog-close]="false" id="btn-make-changes" class="ok">Make Changes</button>
        <button mat-raised-button [mat-dialog-close]="true" id="btn-confirm" class="ok">Confirm</button>
    </div>

</form>

